import React from "react";
import useMobileBreakpoint from "@src/hooks/useMobileBreakpoint";
import { mobileBreakpoint } from "../../../../entrypoints/theme";
import OverlayedLayout from "./layouts/Overlayed";
import TwoColumnLayout from "./layouts/TwoColumn";
import TwoColumnGridLayout from "./layouts/TwoColumnGrid";

const layouts = {
  overlayed: OverlayedLayout,
  "2column": TwoColumnLayout,
  "twocolumn-grid": TwoColumnGridLayout
};

export const TextWithMedia = ({
  reverselayout,
  description,
  settings,
  blocks,
  additional
}) => {
  const isMobile = useMobileBreakpoint(mobileBreakpoint);
  let Layout = layouts[settings.layout_type] || TwoColumnLayout;

  if (isMobile) {
    Layout = layouts[settings.layout_type_mobile] || TwoColumnLayout;
  }

  // Ensure additional data has fallback alt text
  let safeAdditional = additional;
  
  if (additional) {
    try {
      const additionalData = typeof additional === 'string' ? JSON.parse(additional) : additional;

      if (Array.isArray(additionalData)) {
        const processedData = additionalData.map(item => ({
          ...item,
          image_alt: item.image_alt || ""
        }));
        safeAdditional = JSON.stringify(processedData);
      } 
      else if (additionalData && typeof additionalData === 'object') {
        safeAdditional = JSON.stringify({
          ...additionalData,
          image_alt: additionalData.image_alt || ""
        });
      }
    } catch (error) {
      console.error('Error parsing additional data:', error);
      safeAdditional = JSON.stringify({ image_alt: "" });
    }
  } else {
    safeAdditional = JSON.stringify({ image_alt: "" });
  }

  return (
    <div
      className={`${settings.reveal_animation_class} relative`}
      style={{
        paddingTop: `${settings.padding_top}px`,
        paddingBottom: `${settings.padding_bottom}px`,
      }}
    >
      <div className="relative items-end justify-end w-full h-full">
        <Layout
          blocks={blocks}
          description={description}
          reverselayout={reverselayout}
          settings={settings}
          additional={safeAdditional}
        />
      </div>
    </div>
  );
};

